import React, {Component} from 'react'
import Meta from "../Meta";
import Header from "../components/Header";
import Footer from "../components/Footer";
import WebEditorRender from "../../../components/WebEditor";
import AiHtmlIframe from "../../../components/AiHtmlIframe";
import {ASSET_URL} from "../../../config";
import {applyLang} from "../../../i18n";
import Loader from "../loader";
import logger from "../../../services/logger"

export default class CustomPage extends Component{

    render(){
        const context=this.props.context
        const {org,config,data}=context

        logger.debug({ data }, "data")

        const page=applyLang(data[0],context.lang)

        const title=page.title
        const description=page.description

        logger.debug({ page }, "page")

        let lang=context.lang?.value || null
        const languages=context.org.languages || []
        if(languages.length>0 && !lang){
            lang=context.org.language
        }

        const metaTitle=page.metaTitle || title
        const metaDescription=page.metaDescription || description
        const metaImage=page.metaImage?ASSET_URL+page.metaImage:null

        if(this.props.loading){
            return (
                <div className="travel-page travel-page--home">
                    <Meta context={context} seo={page} title={metaTitle} description={metaDescription} image={metaImage}/>
                    <Loader/>
                </div>
            )
        }

        return(
            <div className="travel-page travel-page--home">
                <Meta context={context} seo={page} title={metaTitle} description={metaDescription} image={metaImage}/>
                <Header context={context}/>
                <div style={context.render !== "embed"?{marginTop: 20,minHeight:"80vh"}:undefined}>
                    {page.editorType==="AI" ?(
                        <AiHtmlIframe html={page.html} i18n={page.i18n} mainLang={page.mainLang} lang={lang} linkBehavior="top"/>
                    ):(
                        <WebEditorRender page={page} lang={lang}/>
                    )}
                </div>
                <Footer context={context}/>
            </div>
        )
    }
}
